import ImageContainer from '../General/ImageContainer';
import FormControl from './FormControl';

const iconStyle = {
    width: '20px',
};

const FormRow = props => {
    const { def, state } = props;

    if (state.hidden) return null;

    switch (def.shape) {
        case "vertical":
        case "wide":
        case "attest":
        case "html":
            return <WideRow {...props} />;

        case "normal":
        case "threecol":
            return <DefaultRow {...props} />;

        default:
            return <DefaultRow {...props} />;
    }
}

const WarningLabel = ({ warning, dataWarning }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', marginTop: '2px' }} data-warning={dataWarning}>
            <ImageContainer iconName='circle-arrow-left' styles={iconStyle} className='fontawesomeRed' />
            <div style={{ marginLeft: '4px' }}>
                {warning}
            </div>
        </div>
    )
}

const DefaultRow = props => {
    const { dataKey, def, state, data, warning, onChange } = props;

    const optional = state.required ? '' : ' (optional)';
    const labelStyle = warning
        ? { color: "red" }
        : {};


    return <div style={{ marginTop: "10px", display: 'flex', flexDirection: 'row' }}>
        <div style={{ ...labelStyle, minWidth: '37.5%', paddingRight: '12px', textAlign: 'right' }} data-label={`label_de_${dataKey}`}>
            {def.label.trim()}{optional}
        </div>
        <div style={{ minWidth: '37.5%', padding: '0px 12px' }}>
            <FormControl
                def={def}
                dataKey={dataKey}
                data={data}
                state={state}
                warning={warning}
                onChange={onChange}
            />
        </div>
        <div style={{ minWidth: '25%', padding: '0px 12px', verticalAlign: 'top' }}>
            {warning && <WarningLabel warning={warning} dataWarning={`warning_de_${dataKey}`} />}
        </div>
    </div>
}

const WideRow = props => {
    const { def, data, dataKey, state, warning, onChange } = props;

    const optional = state.required || def.type === 'markdown' || def.type === 'html' ? '' : ' (optional)';
    const labelStyle = warning
        ? { color: "red" }
        : {};

    return <div style={{ marginTop: "10px", display: 'flex', flexDirection: 'row', paddingBottom: '28px' }}>
        <div style={{ width: '75%', paddingLeft: '32px' }}>
            {def.label &&
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} data-label={`label_de_${dataKey}`}>
                    <h5 style={{ ...labelStyle, paddingBottom: '6px' }}>{def.label.trim()}{optional}</h5>
                </div>
            }

            <FormControl
                def={def}
                dataKey={dataKey}
                data={data}
                state={state}
                warning={warning}
                onChange={onChange}
            />
        </div>
        <div style={{ minWidth: '25%', maxWidth: '25%', padding: '0px 12px', overflow: 'wrap' }} verticalAlign='top'>
            {warning && <WarningLabel warning={warning} dataWarning={`warning_de_${dataKey}`} />}
        </div>
    </div>
}

export default FormRow;
